import { render, staticRenderFns } from "./CalendarList.vue?vue&type=template&id=146b35f4&"
import script from "./CalendarList.vue?vue&type=script&lang=js&"
export * from "./CalendarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.STrKMrcDoQYq/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('146b35f4')) {
      api.createRecord('146b35f4', component.options)
    } else {
      api.reload('146b35f4', component.options)
    }
    module.hot.accept("./CalendarList.vue?vue&type=template&id=146b35f4&", function () {
      api.rerender('146b35f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList.vue"
export default component.exports